// Hard-coded feature flags for staged rollouts.
// Flip a flag to true to surface the related UI; defaults are conservative
// so anything in-progress stays hidden from end users until it's ready.
//
// Usage:
//   import { NEXT_FEATURES } from "../featureFlags";
//   if (NEXT_FEATURES) { ... }

export const NEXT_FEATURES = false;
